export const INITIAL_REDIRECT_STATE = 'initialRedirectState';
